import React from 'react';

import { Moon, Sun } from 'lucide-react';

import { useTheme } from '@src/context/hooks';

import { Button } from './Button';


/** Sun/moon ghost button that flips the dark/light token ladder (ThemeContext). */
const ThemeToggle = React.forwardRef((props, ref) => {
  const { className, ...restProps } = props;
  const theme = useTheme();

  if (!theme) {
    return null;
  }

  return (
    <Button
      ref={ref}
      size="icon"
      type="button"
      variant="ghost"
      className={className}
      aria-label={theme.isLight ? 'Switch to dark theme' : 'Switch to light theme'}
      onClick={theme.toggle}
      {...restProps}
    >
      {theme.isLight ? <Moon /> : <Sun />}
    </Button>
  );
});

ThemeToggle.displayName = 'ThemeToggle';

export { ThemeToggle };
export default ThemeToggle;
